/** Routes that use the io-blue Figma shell (header, full-bleed main). */
export const IO_BRAND_PATHS = new Set([
  '/',
  '/about-us',
  '/contact-us',
  '/smart-house-real-estate',
  '/smart-manufacturing',
  '/smart-hospitality',
  '/smart-commercial-lighting',
  '/developer-guide',
  '/api-documentation',
  '/product-guide',
  '/platform',
  '/partner-login',
  '/partner-registration',
]);

/** Routes whose first screen is the blue hero — header scrolls from transparent blue to light. */
export const IO_HERO_LANDING_PATHS = new Set([
  '/',
  '/about-us',
  '/contact-us',
  '/smart-house-real-estate',
  '/smart-manufacturing',
  '/smart-hospitality',
  '/smart-commercial-lighting',
  '/developer-guide',
  '/api-documentation',
  '/platform',
]);

const PLATFORM_PREFIX = '/platform';

export function isPlatformPath(pathname: string): boolean {
  return pathname === PLATFORM_PREFIX || pathname.startsWith(`${PLATFORM_PREFIX}/`);
}

export function isIoBrandPath(pathname: string): boolean {
  return IO_BRAND_PATHS.has(pathname) || isPlatformPath(pathname);
}

export function isIoHeroLandingPath(pathname: string): boolean {
  return IO_HERO_LANDING_PATHS.has(pathname) || isPlatformPath(pathname);
}
